'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const moment=require('pulsar-utils/dist-es6/time/moment');
const StatisticsPanelHelpers=require('../../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const BaseControllerBackedDirective=require('../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

DaysSinceLastIncidentDirective=function(_BaseControllerBacked){_inherits(DaysSinceLastIncidentDirective,_BaseControllerBacked);function DaysSinceLastIncidentDirective(){_classCallCheck(this,DaysSinceLastIncidentDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(DaysSinceLastIncidentDirective,[{key:'templateUrl',get:function()
{return'/templates/directives/statisticsPanels/daysSinceLastIncident/daysSinceLastIncidentTemplate'}},{key:'controller',get:function()
{return DaysSinceLastIncidentDirectiveController}},{key:'objectBindings',get:function()
{return['incidents','pathStartTime','dimensions','interval','homeTimezone','preventAnimations']}}]);return DaysSinceLastIncidentDirective}(BaseControllerBackedDirective);let


DaysSinceLastIncidentDirectiveController=function(){
function DaysSinceLastIncidentDirectiveController($scope,$timeout,dateService){var _this2=this;_classCallCheck(this,DaysSinceLastIncidentDirectiveController);
this._$scope=$scope;
this._$timeout=$timeout;
this._dateService=dateService;

const _redrawIfNew=function(newType,oldType){
if(!_.exists(newType)||newType===oldType){
return;
}
$timeout(function(){
_this2._setupGraphViewData();
});
};

$scope.$watch('controller.incidents',_redrawIfNew);

this._setupGraphViewData();
}DaysSinceLastIncidentDirectiveController.prototype.

_setupGraphViewData=function _setupGraphViewData(){
const{
graphViewData:graphViewData,
daysSinceMostRecentIncident:daysSinceMostRecentIncident,
graphYAxisDomain:graphYAxisDomain,
graphXAxisDomain:graphXAxisDomain}=
StatisticsPanelHelpers.getDaysSinceLastIncidentGraphViewData(this.pathStartTime,this.incidents,this.homeTimezone,this.interval);

this.graphViewData=graphViewData;
this.daysSinceMostRecentIncident=daysSinceMostRecentIncident;
this.graphYAxisDomain=graphYAxisDomain;
this.graphXAxisDomain=graphXAxisDomain;
};return DaysSinceLastIncidentDirectiveController}();


module.exports=DaysSinceLastIncidentDirective;
//# sourceMappingURL=daysSinceLastIncidentDirective.js.map
